import { setProductDeliveryStatusUrl } from "../../api/endpoints";

const EachProductBought = ({ product, orderID, setSelectedOrder, fetchRecievedOrders, setReloadDeliveryGauge, socket, selectedOrder, store, userCurrency }) => {
  const updateDeliveryStatus = async (status) => {
    try {
      let response = await fetch(setProductDeliveryStatusUrl + orderID + "/" + product._id, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          deliveryStatus: status,
        }),
      });
      if (response.ok) {
        let updatedReceivedOrder = await response.json();
        console.log(updatedReceivedOrder);
        setSelectedOrder(updatedReceivedOrder);
        fetchRecievedOrders();
        setReloadDeliveryGauge(true);
        console.log("emitting");
        socket.emit("updateOrderStatus", {
          room: selectedOrder.customer._id,
          message: `${product.name} from ${store.storeName} has been ${status}`,
          updatedOrder: updatedReceivedOrder,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  let imageUrl = `${product.productImage[0].split("/upload/")[0]}/upload/f_auto,q_auto,w_140/${product.productImage[0].split("/upload/")[1]}`;
  return (
    <>
      <div className='eachProductBoughtCont'>
        <div>
          <div className='productImageDiveBouee4'>
            <img src={imageUrl} />
          </div>
          <div>
            <div className='titleANdQuantityConta'>
              <p className='titleProduct21'>{product.name}</p>
              <div>
                <span className='titleQTYTage'>Qty:</span> <span> {product.purchasedQuantity} </span>
              </div>
            </div>
            <p className='id5Detaildd'>
              <span>Unit price</span>
              <span>
                {userCurrency} {product.unitPrice}
              </span>
            </p>
            <p className='id5Detaildd'>
              <span>Delivery Fee</span>
              <span>
                {userCurrency} {product.deliveryFee}
              </span>
            </p>

            <p className='totalPrice11d2'>
              <span>Total:</span>
              <span>
                {userCurrency} {product.purchasedQuantity * product.unitPrice + product.deliveryFee}{" "}
              </span>
            </p>
          </div>
        </div>
        {product.deliveryStatus === "pending" && (
          <div className='productControlDiv343'>
            <div className='pendingItem11'>Pending</div>
            {selectedOrder.orderDetails.orderStatus === "query" ? (
              <button style={{ opacity: "0.6", cursor: "not-allowed" }}>Mark as shipped</button>
            ) : (
              <button onClick={() => updateDeliveryStatus("shipped")}>Mark as shipped</button>
            )}
          </div>
        )}
        {product.deliveryStatus === "shipped" && (
          <div className='productControlDiv343'>
            <div className='pendingItem11'>Shipped</div>
            {selectedOrder.orderDetails.orderStatus === "query" ? (
              <button style={{ backgroundColor: "#F48C5B", opacity: "0.7", cursor: "not-allowed" }}>Mark as delivered</button>
            ) : (
              <button onClick={() => updateDeliveryStatus("delivered")} style={{ backgroundColor: "#F48C5B" }}>
                Mark as delivered
              </button>
            )}
          </div>
        )}
        {product.deliveryStatus === "delivered" && (
          <div className='productControlDiv343'>
            <div style={{ border: "1px solid green", color: "green" }} className='pendingItem11'>
              Delivered
            </div>
            {/* <button style={{backgroundColor:"green"}} >Item delivered</button> */}
          </div>
        )}
        {product.deliveryStatus === "dispute" && (
          <div className='productControlDiv343'>
            <div style={{ border: "1px solid orange", color: "orange" }} className='pendingItem11'>
              disputed
            </div>
            {/* <button style={{backgroundColor:"green"}} >Item delivered</button> */}
          </div>
        )}
        {product.deliveryStatus === "resolved" && (
          <div className='productControlDiv343'>
            <div style={{ backgroundColor: "#AAB3F8", color: "white", border: "none" }} className='pendingItem11'>
              resolved
            </div>
            {/* <button style={{backgroundColor:"green"}} >Item delivered</button> */}
          </div>
        )}
      </div>
    </>
  );
};

export default EachProductBought;
